<template>
    <div class="app-practices">
         <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>

         <div class="my-5">
             <div class=" py-5">
                 <div class="">

                     <div id="masonry-container" class="cbp cbp-l-grid-masonry-projects">

                         <div class="cbp-item practice-item" 
                            v-for="(practice, i) in practices" :key="i"
                            @click="navigateToPractice(practice.dash, practice.mask)"
                        >
                            <div class="practice-img">
                                <img :src="practice.image" :alt="practice.name">
                            </div>
                            <div class="overlay">
                                <div class="text text-capitalize">{{ practice.name }}</div>
                            </div>
                        </div>

                     </div>

                 </div>
             </div>
         </div>
    </div>
</template>

<script>
    let heroImage = require('@/assets/img/footer/footer.jpg');
    let cbp = require('@/assets/css/cubeportfolio.min.css');
    import TopHero from '@/components/frontend/Hero.vue'
    import axios from 'axios'
    import { practicesOptions } from '@/assets/js/exports.js'

    export default {
        components: {
            TopHero: TopHero, 
        },
        name: 'Index',
        data() {
            return {
                heroImage: heroImage,
                title: 'Practice Areas',
                practices: [],
                contentLoaded: false,
                fakeItems: 6
            }
        },
        metaInfo() {
            return {
                title: this.title,
                link: [
                    { rel: 'stylesheet', href: cbp },
                ]
            }
        },
        methods: {
            fetchPractices() {

                axios.get(APIURL + 'practices')
                .then((response) => {
                    this.practices = response.data;

                    this.$nextTick(function() {
                        $('#masonry-container').cubeportfolio(practicesOptions);
                    })
                })
                .catch((err) => {
                    console.log(err);
                })
            },

            //Navigate to 
            navigateToPractice(dash, mask) {
                if (!dash && !mask) {
                    return;
                }
                this.$router.push(`/practice-areas/${dash}/${mask}`);
            }
        },
        created() {
            
            this.fetchPractices();
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/frontend/practice/Index.vue